module.exports = __webpack_public_path__ + "img/tianmao.9d4ead94.png";